import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from "react-i18next";
import { ButtonHLPure, DialogSystemGLPure, InputHLPure, PanelBarHLPure, PromotionalFooterPure, SimpleLoading, SubtitlePageHLPure, TextAreaHLPure } from '../../pures';
import { Container, Grid, useMediaQuery } from '@material-ui/core';
import { Link } from "react-router-dom";
import { profileIconDefault } from '../../../assets/logos/icons';
import autografa from "../../../assets/logos/autografa.png";
import avanzada from "../../../assets/logos/avanzada.png";
import efirma from "../../../assets/logos/efirma.png";
import PdfReader from "../../pures/adobePfdReader/PdfReader";
import DialogEditExpirationDate from "../../pures/signature-request-detail/dialog-edit-expiration-date";
import DialogAcceptSignatureESignature from "../../pures/signature-request-detail/dialog-accept-signature-e-firma";
import DialogAcceptSignatureElectronica from "../../pures/signature-request-detail/dialog-accept-signature-electronica";
import DialogRejectSignature from "../../pures/signature-request-detail/dialog-reject-signature";
import DialogAcceptSignatureAutografaCustom from "../../pures/signature-request-detail/dialog-accept-signature-autografa-custom";
import DialogResendSignatureRequest from "../../pures/dialog-resend-signature-request/dialog-resend-signature-request.pure";
import DialogReactivateSignatureRequest from "../../pures/dialog-reactivate-signature-request/dialog-reactivate-signature-request.pure";
import DialogDeleteSignaturePure from "../../pures/dialog-delete-signature/dialog-delete-signature.pure";
import { ConservacionMensajeImage, EstampadoTiempoImage } from "../../../assets/logos/icons";
import { Dialog } from "@progress/kendo-react-dialogs";
import { PDFDocument } from "pdf-lib";
import { useHistory } from 'react-router-dom';
import "./new-signature-detail.view.css";
import OldDialogRejectSignature from '../../pures/signature-request-detail/old-dialog-reject-signature';
import OldDialogAcceptSignatureAutografaCustom from '../../pures/signature-request-detail/old-signature-autograph';
import OldDilogElectronicSiganture from '../../pures/signature-request-detail/old-dialog-electronic-signature';
import OldDialogAcceptSignature from '../../pures/signature-request-detail/old-dialog-esignature';

const NewSignatureDetailView = (props) => {

    const { t } = useTranslation();
    let history = useHistory();

    let {
        token,
        user,
        isLoadingView,
        showErrorRequesting,
        messageError,
        messageComplete,
        messageWarning,
        showLoadingRequesting,
        showCompletedRequesting,
        showWarningRequesting,
        toggleErrorRequesting,
        toggleLoadingRequesting,
        toggleCompletedRequesting,
        toggleWarningRequesting,
        toggleLoadingScreen,
        signatureRequestInfo,
        signatureRequestId,
        signatureTypes,
        createMessage,
        usersChat,
        conversation,
        membersChat,
        signers,
        userCanEditExpirationDate,
        expirationDate,
        onUpdateExpirationDate,
        toggleEditExpirationDate,
        signStatusName,
        signStatusColor,
        signRequestPDFURL,
        notifyClient,
        completedRequest,
        openDialog,
        setIsShowAutorizationModal,
        imgSignature,
        setImgSignature,
        signRequestPDF,
        onSubmit,
        showBtnNotify,
        idPrecharge,
        idVault,
        sendToDigitalVault,
        authorizerCanSign,
        userCanSign,
        toggleDialogResendSignatureRequest,
        onResendSignatureRequest,
        toggleDialogReactivateSignatureRequest,
        onReactivateSignatureRequest,
        signgRequestIsPackage,
        documentsPackage,
        showCancellationReason,
        cancellationReason
    } = props

    const [currentSignaturetype, setCurrentSignaturetype] = useState({})
    const [signatureTypeImg, setSignatureTypeImg] = useState('')
    const [addIcons, setAddIcons] = useState([])
    const [nameSignature, setNameSignature] = useState('')
    const [resumeSignature, setResumeSignature] = useState('')
    const [notes, setNotes] = useState('')
    const [signerSelectedGrid, setSignerSelectedGrid] = useState({})
    const [urlPdf, setUrlPdf] = useState("");
    const [dataGridDocumentsSign, setDataGridDocumentsSign] = useState([])
    const [documentSelectedGrid, setDocumentSelectedGrid] = useState({})
    const [filePdf, setFilePDF] = useState({});
    const [currentUser, setCurrentUser] = useState({});
    const [signatures, setSignatures] = useState([]);
    const [result, setResult] = useState(null);
    const [showPdfSignatures, setShowPdfSignatures] = useState(false);
    const [currentSystem, setCurrentSystem] = useState("");
    const [showBtnSendBoveda, setShowBtnSendBoveda] = useState(false)
    const [showBtnClasifyBoveda, setShowBtnClasifyBoveda] = useState(false)
    const [showTextSigns, setShowTextSigns] = useState(false)
    const [showIconProofOflife, setShowIconProofLife] = useState(false)

    const toggleShowPdfSignatures = () =>
        setShowPdfSignatures(!showPdfSignatures);

    const autographySignImg = "data:image/png;base64," + props.signatureRequestInfo.autographySign
    const pdf = useMemo(
        () => (
            <PdfReader
                className="pdfReader"
                url={urlPdf}
                awsURL
                showDownloadPDF={true}
            />
        ),
        [urlPdf]
    );

    let infodevice = currentSystem.toLowerCase();
    let isMobile = infodevice.includes("android");
    isMobile = isMobile || infodevice.includes("iphone");
    isMobile = isMobile || infodevice.includes("ipad");
    isMobile = isMobile || infodevice.includes("mobile");

    const is1366 = useMediaQuery("(max-width:1366px)");
    const is650 = useMediaQuery("(max-width: 650px)")
    const is560 = useMediaQuery("(max-width:560px)");

    let showColumnRol = false
    let showColumnStatus = true


    if (is1366) {
        showColumnStatus = false
    }

    const numSign = currentUser.numSign || 1;

    const headerColumnOneItem1 = (props) => {
        return <span className="newSignatureDetailView-header-cell-one-item-1">{props.title}</span>;
    };

    const headerColumnTwoItem1 = (props) => {
        return <span className="newSignatureDetailView-header-cell-two-item-1">{props.title}</span>;
    };

    const headerColumnOneItem2 = (props) => {
        return <span className="newSignatureDetailView-header-cell-one-item-2">{props.title}</span>;
    };

    const cellColumnOneItem1 = (props) => {
        return (
            <td className='newSignatureDetailView-cell-one-item-1'>
                <div className="newSignatureDetailView-labels-column1-item1">
                    <p className='newSignatureDetailView-title-column1-item1'>
                        {props.dataItem.name}
                    </p>
                    <p className='newSignatureDetailView-subtitle-column1-item1'>
                        {props.dataItem.email}
                    </p>
                </div>
            </td>
        );
    };

    const cellColumnTwoItem1 = (props) => {
        return (
            <td className="newSignatureDetailView-cell-one-item-2">
                <div className="newSignatureDetailView-container-column2-item1">
                    <p className='newSignatureDetailView-title-column2-item1'>
                        {props.dataItem.signerTypeName}
                    </p>
                </div>
            </td>
        )
    }

    const cellColumnThreeItem1 = (props) => {
        return (
            <td className="">
                <div className="newSignatureDetailView-container-column2-item1">
                    <p className='newSignatureDetailView-title-column2-item1' style={{ color: props.dataItem.color }}>
                        {props.dataItem.signStatusName}
                    </p>
                </div>
            </td>
        )
    }

    let styleTextTitleItem1 = {
        color: '#62789C',
        fontSize: '14px',
        fontFamily: 'Quicksand',
        fontStyle: 'normal',
        fontWeight: 600,
        padding: 0,
        margin: 0
    }

    const cellColumnOneItem2 = (props) => {
        return (
            <td className="newSignatureDetailView-cell-one-item-2">
                <div className="newSignatureDetailView-labels-column1-item1">
                    <p className='newSignatureDetailView-title-column1-item1'>
                        {props.dataItem.documentName}
                    </p>
                    <p className='newSignatureDetailView-subtitle-column1-item1'>
                        {props.dataItem.fileName}
                    </p>
                </div>
            </td>
        );
    };

    useEffect(() => {
        if (!signatureRequestInfo || !signatureRequestInfo.signRequest) return
        let name = signatureRequestInfo.signRequest.name
        let description = signatureRequestInfo.signRequest.description
        let notes = signatureRequestInfo.signRequest.comments

        if (signgRequestIsPackage && documentsPackage && documentsPackage.length > 0) {
            documentsPackage = documentsPackage.sort((a, b) => {
                if (a.documentName < b.documentName) return -1
                if (a.documentName > b.documentName) return 1
                return 0
            })
            setDataGridDocumentsSign(documentsPackage)
        }

        setNameSignature(name)
        setResumeSignature(description)
        setNotes(notes)
    }, [signatureRequestInfo])

    useEffect(() => {
        if (!signatureRequestInfo || !signatureRequestInfo.signRequest || !signatureTypes || !signatureTypes.length === 0) return
        let signatureType = signatureTypes.find((type) => type.id === signatureRequestInfo.signRequest.signatureTypeId)
        let signatureImg = ''
        switch (signatureType.id) {
            case 1:
                signatureImg = efirma
                break;
            case 2:
                signatureImg = avanzada
                break;
            case 3:
                signatureImg = autografa
                break;
            default:
                signatureImg = autografa
                break;
        }

        let icons = []
        let services = signatureRequestInfo.servicesInSignsRequest
        services = [...new Map(services.map(item => [item.service.id, item])).values()];
        services.map((service) => {
            let icon = {}
            let serviceIcon = ConservacionMensajeImage;
            if (
                service.service.id ===
                Number(
                    process.env
                        .REACT_APP_ADDITIONAL_SERVICES_TIME_DOCUMENT
                )
            )
                serviceIcon = EstampadoTiempoImage;
            if (
                service.service.id ===
                Number(
                    process.env
                        .REACT_APP_ADDITIONAL_SERVICES_TIME_BY_SIGNATURE
                )
            )
                serviceIcon = EstampadoTiempoImage;
            icon.name = service.service.name
            icon.description = ''
            icon.img = serviceIcon
            icon.position = 'top'
            icons.push(icon)
            return service
        })

        let icon = {}
        icon.name = 'Tipo de firma'
        icon.description = signatureType.name
        icon.img = signatureImg
        icon.position = 'top'
        icons.push(icon)

        let textSignsWatchUntilEnd = ((signatureRequestInfo.signRequest.signatureTypeId !== 3 && !isMobile) && (signatureRequestInfo.signRequest.signRequestStatus.name === 'Pendiente')) ? true : false

        let showIconProofOflife = false
        let proofOfLifeExist = signatureRequestInfo.signersList.some(signer => signer.proofOfLife)
        if (proofOfLifeExist) {
            showIconProofOflife = true
            let icon = {}
            icon.name = process.env.REACT_APP_PROOF_OF_LIFE_NAME
            icon.description = ''
            icon.img = `${process.env.REACT_APP_AWS_S3_BUCKET_URL}microservices/MiFirma/assets/inbox/icono_prueba_de_vida.svg`
            icon.position = 'top'
            icons.push(icon)
        }

        let showIconSignaturesMultiple = (signatureRequestInfo && signatureRequestInfo.inbox && signatureRequestInfo.inbox.solicitudeHasMultipleSignatures) ? true : false
        if (showIconSignaturesMultiple) {
            icons = icons.filter((icon) => icon.name !== 'Tipo de firma')
            let icon = {}
            icon.name = t("signatureRequestDetailView2.tooltip.signtures.multiples.title")
            icon.description = t("signatureRequestDetailView2.tooltip.signtures.multiples.description")
            icon.img = `${process.env.REACT_APP_AWS_S3_BUCKET_URL}microservices/MiFirma/assets/inbox/iconoFirma2.svg`
            icon.position = 'top'
            icons.push(icon)
        }

        setShowTextSigns(textSignsWatchUntilEnd)
        setSignatureTypeImg(signatureImg)
        setCurrentSignaturetype(signatureType)
        setAddIcons(icons)
        setShowIconProofLife(showIconProofOflife)
    }, [signatureRequestInfo, signatureTypes])

    useEffect(() => {
        if (!signRequestPDFURL || signRequestPDFURL === '') return
        setUrlPdf(signRequestPDFURL)
    }, [signRequestPDFURL])

    useEffect(() => {
        if (!props.currentUser || !props.currentUser.email) return
        setCurrentUser(props.currentUser);
        let tempArr = [];
        for (let index = 0; index < props.currentUser.numSign; index++) {
            tempArr.push({ date: null, index: index + 1, page: "" });
        }
        setSignatures(tempArr);
    }, [props.currentUser]);

    useEffect(() => {
        createPdf();
    }, [signatures]);

    useEffect(() => {
        setCurrentSystem(navigator.userAgent);
    }, []);

    useEffect(() => {
        if (!signatureRequestInfo || !signatureRequestInfo.signRequest || !signatureRequestInfo.signRequest.signRequestStatus || idVault === 0) return
        let showSend = (signatureRequestInfo.signRequest.signRequestStatus.id === Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_COMPLET) && idPrecharge === null && (idVault === 14 || idVault === 15)) ? true : false
        let showClasify = (signatureRequestInfo?.signRequest?.signRequestStatus?.id === Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_COMPLET) && idPrecharge !== null && idPrecharge !== undefined) ? true : false
        //Validacion de quitar el boton de enviar a boveda para algunos clientIds

        showSend = false
        showClasify = false
        setShowBtnSendBoveda(showSend)
        setShowBtnClasifyBoveda(showClasify)
    }, [signatureRequestInfo, idPrecharge, idVault])

    useEffect(() => {
        if (!signerSelectedGrid || !signerSelectedGrid.signRequestId || !is560) return
        notifyClient(signerSelectedGrid)
    }, [signerSelectedGrid])

    useEffect(() => {
        if (!documentSelectedGrid || !documentSelectedGrid.documentPathURL || !is560) return
        onHandleWathcDoc(documentSelectedGrid)
    }, [documentSelectedGrid])

    const handleNameSignature = (e) => {
        setNameSignature(e.target.value)
    }

    const handleResumeSiganture = (e) => {
        setResumeSignature(e.target.value)
    }

    const handleNotes = (e) => {
        setNotes(e.target.value)
    }


    const createPdf = () => {
        let signatureData = signatures.map((i, j) => ({
            x: i.x,
            y: i.y,
            width: i.width,
            height: i.height,
            page: i.page,
            isMobile: true,
            fileSignImage: i.fileSignImage,
            imgSignature: i.imgSignature,
            fileName: `sign${j + 1}`,
        }));
        props.setSignatures(signatureData);
        insertSignByCoordinates(signatureData);
    };

    const insertSignByCoordinates = async (signatureData) => {
        if (!!signatureData.find((i) => i.imgSignature)) {
            const existingPdfBytes = await fetch(
                "data:application/pdf;filename=data.pdf;base64," + signRequestPDF
            ).then((res) => res.arrayBuffer());
            const pdfDoc = await PDFDocument.load(existingPdfBytes);
            const pages = pdfDoc.getPages()
            for (let index = 0; index < signatureData.length; index++) {
                const { x, y, width, height, page, isMobile, imgSignature } =
                    signatureData[index];
                if (imgSignature) {
                    const fileSignImage = await fetch(imgSignature).then((res) =>
                        res.arrayBuffer()
                    );
                    const pageToSign = page <= 0 ? pages[0] : pages[page - 1];
                    const heightPage = pageToSign.getHeight();
                    const pngSignImage = await pdfDoc.embedPng(fileSignImage);
                    pngSignImage.scale(1);
                    pageToSign.drawImage(pngSignImage, {
                        x,
                        y: isMobile ? y : heightPage - y - height,
                        width,
                        height,
                    });
                }
            }
            const pdfBytes = await pdfDoc.saveAsBase64();
            let elnuevopdf =
                "data:application/pdf;filename=data.pdf;base64," + pdfBytes;
            setResult(elnuevopdf);
        }
    };

    const onHandleWathcDoc = (documento) => {
        setUrlPdf(documento.documentPathURL)
    }

    const handleInputChangeChat = (e) => {
        let file = e.target.files[0];
        setFilePDF(file);
    };

    const onHandleBack = () => {
        history.goBack()
    }

    return (
        <div className="newSignatureDetailView-wrapper">
            {
                isLoadingView ? (
                    <SimpleLoading />
                )
                    : (
                        <Container
                            xs={12}
                            lg={12}
                            md={12}
                            sm={12}
                            spacing={4}
                            className="newSignatureDetailView-container"
                        >
                            <Grid
                                item
                                lg={12}
                                md={12}
                                xs={12}
                                sm={12}
                                className="newSignatureDetailView-header"
                            >
                                <SubtitlePageHLPure
                                    subtitle={t("newSignatureDetailView.title")}
                                    imgProfile={profileIconDefault}
                                    profileImg={""}
                                    tooltipShow={false}
                                    moreIcos={addIcons}
                                    textRight={true}
                                    subtitleRight={'Estado:'}
                                    statusContract={signStatusName}
                                    colorStatusContract={signStatusColor}
                                />
                            </Grid>
                            <Grid
                                container
                                className="newSignatureDetailView-body"
                                xs={12}
                                lg={12}
                                md={12}
                                sm={12}
                                es={12}
                            >
                                <div className='newSignatureDetailView-container-data-singature'>
                                    <div className='newSignatureDetailView-name-signature'>
                                        <InputHLPure
                                            valueInput={nameSignature}
                                            labelInput={t("newSignatureDetailView.name.signature")}
                                            typeInput={"text"}
                                            handleChangeInput={(e) => handleNameSignature(e)}
                                            inputActive={true}
                                            styleInput={{ 'textDecoration': 'none' }}
                                            disabled
                                        />
                                    </div>
                                    {/* <div className='newSignatureDetailView-resume-signature'>
                                        <TextAreaHLPure
                                            labelTextArea={t("newSignatureDetailView.resume.signature")}
                                            valueTextData={resumeSignature}
                                            positionTooltip={"right"}
                                            handleChangeTextArea={(e) => handleResumeSiganture(e)}
                                            disabled
                                        />
                                    </div> */}
                                    <TextAreaHLPure
                                        labelTextArea={t("newSignatureDetailView.notes.signature")}
                                        valueTextData={notes}
                                        positionTooltip={"right"}
                                        handleChangeTextArea={(e) => handleNotes(e)}
                                        disabled
                                    />
                                    {
                                        showCancellationReason && (
                                            <div className='newSignatureDetailView-cancellation'>
                                                <TextAreaHLPure
                                                    labelTextArea={t("newSignatureDetailView.cancellation.reason")}
                                                    valueTextData={cancellationReason}
                                                    disabled
                                                />
                                            </div>
                                        )
                                    }
                                </div>
                                <div className='newSignatureDetailView-container-panelBars-pdf'>
                                    <PanelBarHLPure
                                        styleGeneral1={true}
                                        styleGeneralClass1={"newSignatureDetailView-general-grid"}
                                        styleGeneral2={true}
                                        styleGeneralClass2={"newSignatureDetailView-general-grid-2"}
                                        titleItem1={t("newSignatureDetailView.signers")}
                                        titleItem2={t("newSignatureDetailView.documents.to.sign")}
                                        titleItem3={t("newSignatureDetailView.comments.team")}
                                        expandedItem1={true}
                                        expandedItem2={true}
                                        expandedItem3={false}
                                        dataItem1={signers}
                                        setSelectedItem1={setSignerSelectedGrid}
                                        styleTextTitleItem1={styleTextTitleItem1}
                                        columnTwoItem1={showColumnRol}
                                        columnThreeItem1={showColumnStatus}
                                        columnFourItem1={false}
                                        columnFiveItem1={true}
                                        titleRow1Item1={t("newSignatureDetailView.column.name")}
                                        titleRow2Item1={t("newSignatureDetailView.column.rol")}
                                        titleRow3Item1={t("newSignatureDetailView.column.status")}
                                        titleRow4Item1={''}
                                        titleRow5Item1={t("newSignatureDetailView.column.actions")}
                                        headerColumnOneItem1={headerColumnOneItem1}
                                        headerColumnTwoItem1={headerColumnTwoItem1}
                                        headerColumnThreeItem1={headerColumnTwoItem1}
                                        headerColumnFourItem1
                                        cellColumnOneItem1={cellColumnOneItem1}
                                        cellColumnTwoItem1={cellColumnTwoItem1}
                                        cellColumnThreeItem1={cellColumnThreeItem1}
                                        cellColumnFourItem1
                                        textTitleItem1={t("newSignatureDetailView.signers.authorizers")}
                                        textDateLimit={t("newSignatureDetailView.date.limit")}
                                        iconOneActiveItem1={false}
                                        iconTwoActiveItem1={false}
                                        iconThirdActiveItem1={false}
                                        iconFourthActiveItem1={false}
                                        labelOneActionsItem1={'Notificar'}
                                        labelTwoActionsItem1={''}
                                        labelThirdActionsItem1={''}
                                        labelFourthActionsItem1={''}
                                        activeDialog1Item1={true}
                                        btnOpenDialog1Item1={(dataItem) => notifyClient(dataItem)}
                                        labelBtnDate={t("newSignatureDetailView.edit.date.limit")}
                                        handleBtnDate={toggleEditExpirationDate}
                                        dataItem2={dataGridDocumentsSign}
                                        setSelectedItem2={setDocumentSelectedGrid}
                                        setNameComponentUserItem1={() => console.log('')}
                                        setShowDetailsItem1={() => console.log('')}
                                        columnTwoItem2={false}
                                        columnThreeItem2={false}
                                        columnFourItem2={false}
                                        columnFiveItem2={true}
                                        titleRow1Item2={t("newSignatureDetailView.column.name")}
                                        titleRow2Item2={''}
                                        titleRow3Item2={''}
                                        titleRow4Item2={''}
                                        titleRow5Item2={t("newSignatureDetailView.column.actions")}
                                        headerColumnOneItem2={headerColumnOneItem2}
                                        setNameComponentUserItem2={() => console.log('')}
                                        setShowDetailsItem2={() => console.log('')}
                                        cellColumnOneItem2={cellColumnOneItem2}
                                        iconOneActiveItem2={true}
                                        iconTwoActiveItem2={false}
                                        iconThirdActiveItem2={false}
                                        iconFourthActiveItem2={false}
                                        labelOneActionsItem2={t("newSignatureDetailView.view.document")}
                                        labelTwoActionsItem2={''}
                                        labelThirdActionsItem2={''}
                                        labelFourthActionsItem2={''}
                                        activeDialog1Item2={true}
                                        btnOpenDialog1Item2={(dataItem) => onHandleWathcDoc(dataItem)}
                                        usersChat={usersChat}
                                        conversation={conversation}
                                        handleInputChangeChat={(e) => handleInputChangeChat(e)}
                                        createMessage={createMessage}
                                        membersChat={membersChat}
                                        userCanEditExpirationDate={userCanEditExpirationDate}
                                        expirationDate={expirationDate}
                                        showTextSigns={showTextSigns}
                                        showBarItem2={signgRequestIsPackage}
                                        takeItem1={signers.length}
                                        pageableItem1={false}
                                        styleGridItem1={{ maxHeight: '400px' }}
                                        pageableItem2={false}
                                        takeItem2={dataGridDocumentsSign.length}
                                        styleGridItem2={{ maxHeight: '400px' }}
                                    />
                                    <div className='newSignatureDetailView-container-pdf'>
                                        <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            className="newSignatureDetailView-pdf"
                                        >
                                            {pdf}
                                        </Grid>
                                    </div>
                                </div>
                                <div className='newSignatureDetailView-container-btns'>
                                    <div className='newSignatureDetailView-btn-back'>
                                        <ButtonHLPure
                                            nameBtn={t("button.return")}
                                            onClickBtn={() => onHandleBack()}
                                            primary={false}
                                        />
                                    </div>
                                    {
                                        props.userCanCancelSignRequest && is650 && <DialogDeleteSignaturePure
                                            {...props}
                                            signatureRequest={props.signatureRequestInfo}
                                            toggleDialogDeleteRequest={props.toggleDialogDeleteRequest}
                                            handleCommentsDelete={props.handleCommentsDelete}
                                            deleteSignRequest={props.deleteSignRequest}
                                        />
                                    }
                                    {
                                        is650 && <Link
                                            to={{
                                                pathname: `/document-tracking/${signatureRequestInfo.signRequest.id}`,
                                                params: { dataItem: signatureRequestInfo.inbox },
                                            }}
                                            style={{ textDecoration: "none", display: "contents" }}
                                        >
                                            <ButtonHLPure
                                                nameBtn={t("signatureRequestDetailView2.buttonDocumentTracking")}
                                                onClickBtn={props.scrollWindow}
                                            />
                                        </Link>
                                    }
                                    {(userCanSign === true || authorizerCanSign === true) ? (
                                        <div className='newSignatureDetailView-btn-reject'>
                                            <OldDialogRejectSignature {...props} signatureRequest={signatureRequestInfo} />
                                        </div>
                                    ) : null
                                    }
                                    <OldDialogAcceptSignature
                                        {...props}
                                        setIsShowAutorizationModal={setIsShowAutorizationModal}
                                        imgSignature={imgSignature}
                                        setImgSignature={setImgSignature}
                                        currentSignaturetype={currentSignaturetype ?? {}}
                                        signatureRequest={signatureRequestInfo}

                                    />
                                    <OldDilogElectronicSiganture
                                        {...props}
                                        setIsShowAutorizationModal={setIsShowAutorizationModal}
                                        imgSignature={imgSignature}
                                        setImgSignature={setImgSignature}
                                        currentSignaturetype={currentSignaturetype ?? {}}
                                        signatureRequest={signatureRequestInfo}

                                    />
                                    {/* {numSign === 1 ? ( */}
                                    <OldDialogAcceptSignatureAutografaCustom
                                        {...props}
                                        noRenderSign={true}
                                        signatures={signatures}
                                        currentUser={currentUser}
                                        setIsShowAutorizationModal={
                                            setIsShowAutorizationModal
                                        }
                                        imgSignature={imgSignature}
                                        setImgSignature={setImgSignature}
                                        currentSignaturetype={currentSignaturetype}
                                        signatureRequest={signatureRequestInfo}

                                        result={result}
                                        setSignatures={setSignatures}
                                        setAllSignatures={props.setSignatures}
                                        insertSignByCoordinates={insertSignByCoordinates}
                                        toggleLoadingRequesting={props.toggleLoadingRequesting}

                                        autographySign={autographySignImg}
                                    />
                                    {/* ) : (
                                        <React.Fragment>
                                            {authorizerCanSign &&
                                                currentSignaturetype.id ===
                                                Number(
                                                    process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA
                                                ) && (
                                                    <ButtonHLPure
                                                        nameBtn={t("button.authorize")}
                                                        primary
                                                        onClickBtn={() => props.setIsShowAutorizationModal()}
                                                    />
                                                )}
                                            {userCanSign &&
                                                currentSignaturetype.id ===
                                                Number(
                                                    process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA
                                                ) && (
                                                    <React.Fragment>
                                                        <ButtonHLPure
                                                            nameBtn={t("button.send")}
                                                            primary
                                                            onClickBtn={() => {
                                                                createPdf();
                                                                setTimeout(() => {
                                                                    let fileSignImages = signatures.map(
                                                                        (item) => item.imgSignature
                                                                    );
                                                                    let isFullFileSignImages =
                                                                        fileSignImages.reduce(
                                                                            (vp, va) => !!vp && !!va
                                                                        );
                                                                    if (isFullFileSignImages) {
                                                                        onSubmit();
                                                                    }
                                                                }, 100);
                                                            }}
                                                        />
                                                        {showPdfSignatures && !isMobile && (
                                                            <Dialog
                                                                title={t("dialogSignRequestPure.titleDialogSignRequest")}
                                                                onClose={toggleShowPdfSignatures}
                                                            >
                                                                <iframe
                                                                    name="document_pdf"
                                                                    id="myiframe"
                                                                    width="100%"
                                                                    height="600px"
                                                                    src={result}
                                                                    className="canvas_container_pdf_render"
                                                                    title='sign'
                                                                />
                                                                <div className={"btn-conttainer "}>
                                                                    <ButtonHLPure
                                                                        nameBtn={t("dialogResendSignatureRequest.buttonClose")}
                                                                        onClickBtn={toggleShowPdfSignatures}
                                                                    />
                                                                    <ButtonHLPure
                                                                        nameBtn={t("button.send")}
                                                                        onClickBtn={() => {
                                                                            toggleShowPdfSignatures();
                                                                            onSubmit();
                                                                        }}
                                                                    />
                                                                </div>
                                                            </Dialog>
                                                        )}
                                                    </React.Fragment>
                                                )}
                                        </React.Fragment>
                                    )} */}
                                    <div className='newSignatureDetailView-btn-resend'>
                                        <DialogResendSignatureRequest
                                            {...props}
                                            toggleDialogResendSignatureRequest={
                                                toggleDialogResendSignatureRequest
                                            }
                                            onResendSignatureRequest={
                                                onResendSignatureRequest
                                            }

                                            signatureRequest={signatureRequestInfo}
                                            signRequest={signatureRequestInfo.signRequest}
                                        />
                                    </div>
                                    <DialogReactivateSignatureRequest
                                        {...props}
                                        toggleDialogReactivateSignatureRequest={
                                            toggleDialogReactivateSignatureRequest
                                        }
                                        onReactivateSignatureRequest={
                                            onReactivateSignatureRequest
                                        }
                                        signatureRequest={signatureRequestInfo}
                                        signRequest={signatureRequestInfo.signRequest}
                                    />
                                    {showBtnSendBoveda ? (
                                        <React.Fragment>
                                            <ButtonHLPure
                                                nameBtn={t("btn.send.boveda")}
                                                onClickBtn={() => {
                                                    sendToDigitalVault(signatureRequestInfo.signRequest.id);
                                                }}
                                            />
                                        </React.Fragment>
                                    ) : null}
                                    {showBtnClasifyBoveda ? (
                                        <Link to={{ pathname: "/digital-vault-grc", state: { idPrecarga: idPrecharge } }}>
                                            <React.Fragment>
                                                <ButtonHLPure
                                                    nameBtn={t("btn.clasify.boveda")}
                                                />
                                            </React.Fragment>
                                        </Link>
                                    ) : null}
                                </div>
                                <Grid item xs={12} lg={12} md={12} sm={12}>
                                    <PromotionalFooterPure />
                                </Grid>
                            </Grid>
                            <div className='newSignatureDetailView-dialog-date'>
                                <DialogEditExpirationDate
                                    {...props}
                                    toggleEditExpirationDate={toggleEditExpirationDate}
                                    onUpdateExpirationDate={onUpdateExpirationDate}
                                />
                            </div>
                            <DialogSystemGLPure
                                {...props}
                                wrapTextClass="newSignatureDetailView-wrapped-text"
                                showLoadingRequesting={showLoadingRequesting}
                                showCompletedRequesting={showCompletedRequesting}
                                showErrorRequesting={showErrorRequesting}
                                showWarningRequesting={showWarningRequesting}
                                toggleLoadingRequesting={toggleLoadingRequesting}
                                toggleCompletedRequesting={toggleCompletedRequesting}
                                toggleErrorRequesting={toggleErrorRequesting}
                                toggleWarningRequesting={toggleWarningRequesting}
                                message={messageError}
                                messageComplete={messageComplete}
                                messageWarning={messageWarning}
                            />
                        </Container>
                    )
            }
        </div>
    )
}

export default NewSignatureDetailView